import React from 'react';
import * as S from './styles';
import welcomeSuccess from '../../../assets/icons/welcomeSuccess.svg';

export default function WelcomeSuccess({ setRender }) {
  return (
    <div
      style={{
        display: 'flex',
        height: '100%',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <S.SuccessMessage>
        <img src={welcomeSuccess} alt="success" />
        <h1>Cadastro realizado com sucesso!</h1>
        <p>Clique no botão abaixo para retornar a tela de login</p>
        <button onClick={() => setRender('CorpoLogin')}>Login</button>
      </S.SuccessMessage>
    </div>
  );
}
